
export type DisplayNameComponent = Partial<Pick<Function, 'name'>> & {
  displayName?: string;
};

/**
 * @param {React.Component} Component React component
 * @returns {string} component name (or default name if unrecognized)
 */
export const getDisplayName = (Component: unknown): string => (Component as DisplayNameComponent).displayName || (Component as DisplayNameComponent).name || 'Component';
